import axios from "axios";

//Connection
import connectConfig from "@/config/connectConfig";
import { setGlobalMessage } from "@/features/systemSlice";
import { removeUser, setUser } from "@/features/userSlice";
import { getRefreshToken } from "@/fetch/fetchLogin";

import store from "@/store";

var storage = window.localStorage;
const userObjectStorgae = storage.getItem("userObject");
let token = null;
let userObject = {};

if (userObjectStorgae) {
  userObject = JSON.parse(userObjectStorgae);

  token = userObject.token;
}
class Api {
  constructor() {
    this.axios = axios.create();
    this.axios.interceptors.response.use(undefined, async (err) => {
      if (err.code === "ERR_NETWORK") {
        store.dispatch(
          setGlobalMessage({
            message: {
              code: "ERR_NETWORK",
              message: "網絡異常，請檢查。",
              isError: true,
            },
          })
        );
        throw err;
      }

      switch (err.response.status) {
        case 498:
          const userObject = JSON.parse(storage.getItem("userObject"));

          const response = await getRefreshToken(userObject.refreshToken);

          const userData = {
            token: response.token,
            refreshToken: response.refreshToken,
            userRole: response.role_types_id,
            userUrl: response.accessUrl,
            departmentId: response.department_id,
          };

          await store.dispatch(setUser(userData));

          const retry = await this.axios({
            responseType: err.config.responseType,
            method: err.config.method,
            baseURL: err.config.baseURL,
            url: err.config.url,
            data: err.config.data
              ? JSON.parse(
                  err.config.data.replace(/[^\\"]+/).replace("undefined", "{")
                )
              : err.config.data,
          });

          return retry;
        case 499:
        case 403:
          window.location.href = "/login/tokenExpired";
          store.dispatch(removeUser());
          this.setToken();
          break;
        default:
          store.dispatch(
            setGlobalMessage({
              message: {
                code: err.code,
                message: "發生未知錯誤",
                isError: true,
              },
            })
          );
          throw err;
      }
    });
  }
  setUrl(baseURL) {
    this.axios.defaults.baseURL = baseURL;
  }
  setToken(token) {
    this.axios.defaults.headers.Authorization = `${token} `;
    this.axios.defaults.headers.From = "web";
  }
}

const api = new Api();
!(token in ["", undefined]) && api.setToken(token);
connectConfig.backendURL && api.setUrl(connectConfig.backendURL);

export default api;
